import create from 'zustand'
import axios from "../plugins/axios";

const addr = 'https://www.bahabin.com/api/headers';
const abandonedCountries = ["US", "JP", "IL", "CA"];

export const useAbandonedCountriesCheckState = create(
    (set, get) => ({
//        cryptoIsAccessibleInThisCountry: null,
        cryptoIsAccessibleInThisCountry: true,
        setAccessible: (isAccessible) => set({cryptoIsAccessibleInThisCountry: isAccessible}),
        refreshCryptoIsAccessible: () => get().cryptoIsAccessibleInThisCountry == null && callApiToCheckCountryHeader(),
    }));

const callApiToCheckCountryHeader = () => {
    // console.log("callApiToCheckCountryHeader")
    axios
        .post(addr).then((res) => {
            const country = res.data['cf-ipcountry'];
            const accessible = abandonedCountries.includes(country);
            // console.log("accessible", accessible)
            useAbandonedCountriesCheckState.getState().setAccessible(!accessible);
        }
    ).catch((error) => {
        console.log(error)
    });
}